<mat-card class="card-licenca" [ngStyle]="{
        display: imageLoaded ? 'block' : 'none'
    }" appearance="outlined">

    <div class="image-content">
        <img (load)="loadImage()" mat-card-image class="card-image"
            *ngIf="imageFormats.includes(getFileFormatFromUrl(licenca.teste.capa)!.toLocaleLowerCase())" [ngStyle]="{
            'aspect-ratio': constantsWidthHeightMidia.lg.width / constantsWidthHeightMidia.lg.height
        }" [src]="licenca.teste.capa" height="100%" />

        <video (canplay)="loadImage()" mat-card-image class="card-image"
            *ngIf="videoFormats.includes(getFileFormatFromUrl(licenca.teste.capa)!.toLocaleLowerCase())" [ngStyle]="{
            'aspect-ratio': constantsWidthHeightMidia.lg.width / constantsWidthHeightMidia.lg.height
        }" controls>
            <source [src]="licenca.teste.capa" />
        </video>

        <div class="card-badge" *ngIf="imageLoaded">
            <status-badge [tipo]="statusBadge.tipo" [label]="statusBadge.label" [detalhe]="statusBadge.detalhe"
                [tooltip]="statusBadge.tooltip"></status-badge>
        </div>

        <img *ngIf="exibirCadeado()" class="cadeado" src="assets/img/cadeado.svg" [matTooltip]="tooltipCadeado()"
            [matTooltipShowDelay]="600">
    </div>


    <div class="card-content" *ngIf="imageLoaded">
        <mat-card-content class="card-content-text">

            <!-- <div class="liberado-em">Liberado em {{converterData(licenca.data_criacao)}}</div> -->

            <div class="card-title mt-2">{{ licenca.teste.nome }}</div>

            <div class="informacoes-licenca">
                <!-- quando não iniciado e não possui data de quando ficara disponivel -->
                <div class="info-item" *ngIf="!licenca.data_inicio && !licenca.disponivel_de">
                    <mat-icon class="info-item__icon">pending</mat-icon>
                    <div class="info-item__text">
                        <span class="info-item__label">Status</span>
                        <span class="info-item__value">Não iniciado</span>
                    </div>
                </div>

                <!-- quando não iniciado ainda e possui data de disponibilidade -->
                <div class="info-item"
                    *ngIf="licenca.disponivel_de && !licenca.data_inicio && !isDataAtualOuAnterior(licenca.disponivel_de)">
                    <mat-icon class="info-item__icon">schedule</mat-icon>
                    <div class="info-item__text">
                        <span class="info-item__label">Ficará disponível em</span>
                        <span class="info-item__value">{{ converterData(licenca.disponivel_de) }}</span>
                    </div>
                </div>

                <div class="info-item" *ngIf="licenca.data_inicio">
                    <mat-icon class="info-item__icon">play_arrow</mat-icon>
                    <div class="info-item__text">
                        <span class="info-item__label">Início</span>
                        <span class="info-item__value">{{ converterData(licenca.data_inicio) }}</span>
                    </div>
                </div>

                <div class="info-item" *ngIf="licenca.data_fim">
                    <mat-icon class="info-item__icon">check_circle</mat-icon>
                    <div class="info-item__text">
                        <span class="info-item__label">Conclusão</span>
                        <span class="info-item__value">{{ converterData(licenca.data_fim) }}</span>
                    </div>
                </div>
            </div>
        </mat-card-content>

        <mat-card-actions class="card-actions">
            <div class="row">

                <div class="col-6" *ngIf="licenca.data_fim == null && licenca.disponivel_ate"></div>
                <div class="col expiration" *ngIf="licenca.data_fim == null && licenca.disponivel_ate">
                    Expira em
                    {{ converterData(licenca.disponivel_ate) }}
                </div>

                <!-- <div class="mt-2" *ngIf="licenca.data_fim != null">
                    <button mat-mini-fab color="accent" (click)="recomendacoes()">
                        <mat-icon>star</mat-icon>
                    </button>
                    <span class="ms-3">Recomendações</span>
                </div> -->

                <div>
                    <div class="btn-relatorio" *ngIf="licenca.data_fim != null">
                        <a class="cta report" (click)="relatorio()">📄 Ver Relatório</a>
                    </div>
<!-- 
                    <div class="btn-relatorio" *ngIf="licenca.data_fim != null">
                        <a class="cta insights" (click)="recomendacoes()">⭐ Recomendações</a>
                    </div> -->

                    <div *ngIf="podeIniciarLicenca()" class="btn-relatorio">
                        <!-- <button mat-mini-fab color="primary" (click)="iniciar()">
                            <mat-icon>play_arrow</mat-icon>
                        </button> -->

                        <a class="cta play" (click)="iniciar()">
                            <mat-icon>play_arrow</mat-icon>
                            <span class="ms-3" *ngIf="!licenca.data_inicio">Iniciar</span>
                            <span class="ms-3" *ngIf="licenca.data_inicio">Continuar</span>
                        </a>
                    </div>
                </div>


            </div>
        </mat-card-actions>
    </div>

    <div class="card-progresso" *ngIf="licenca.data_inicio">
        <mat-progress-bar mode="determinate" [value]="licenca.progresso"></mat-progress-bar>
        <span class="card-progresso__texto">{{ licenca.progresso }}%</span>
    </div>
</mat-card>

<div class="skeleton-card" *ngIf="!imageLoaded">
    <div class="skeleton-image" [ngStyle]="{
            'aspect-ratio': constantsWidthHeightMidia.lg.width / constantsWidthHeightMidia.lg.height
        }"></div>
    <div class="skeleton-text">
        <div class="skeleton-line short"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
    </div>
</div>